import { visitorRegister } from "@/api/auth";
import { reactive, ref } from "vue";
import { useRouter } from "vue-router";

export default (user) => {

    const router = useRouter();
    const isFetching = ref(false);
    const errors = reactive({
        name: '',
        email: '',
        password: ''
    });

    const success = async (response) => {
        // Account created server-side; an OTP was emailed. The visitor is NOT
        // logged in yet — send them to the email-confirmation screen to verify.
        if (response.data.code != 'VERIFICATION_REQUIRED') {
            return false;
        }

        const email = response.data.data.email;
        try {
            sessionStorage.setItem('pending_verification_email', email);
        } catch (e) {
            // Ignore storage failures (private mode, etc.); the view falls back.
        }

        router.push({ name: 'auth.email-confirmation' });
    };

    const failed = async (error) => {
        if (!error?.response) return false;

        if (error.response.status == 422) {
            for (let e in error.response.data.errors) {
                errors[e] = error.response.data.errors[e][0];
            }
        }

        return false;
    };

    const execute = async () => {
        isFetching.value = true;
        await visitorRegister(user).then(success, failed);
        isFetching.value = false;
    };

    return { execute, isFetching, errors };
};
